interface PuzzleCardProps {
  icon:         string
  label:        string
  description:  string
  /** Tailwind classes for the card border + hover tint, e.g. "border-bubble-coral hover:bg-bubble-coral-light" */
  accentClass:  string
  /** Tailwind class for the icon circle background, e.g. "bg-bubble-coral-light" */
  iconBgClass:  string
  onClick:      () => void
}

export default function PuzzleCard({
  icon,
  label,
  description,
  accentClass,
  iconBgClass,
  onClick,
}: PuzzleCardProps) {
  return (
    <button
      onClick={onClick}
      className={`
        card border-2 p-5 text-center w-full flex flex-col items-center gap-3
        transition-all duration-150 hover:-translate-y-1 hover:shadow-lg
        focus:outline-none focus:ring-2 focus:ring-bubble-coral focus:ring-offset-2
        ${accentClass}
      `}
    >
      <div className={`w-14 h-14 rounded-full flex items-center justify-center text-3xl ${iconBgClass}`}>
        <span aria-hidden>{icon}</span>
      </div>
      <div>
        <h2 className="font-display font-black text-lg text-bubble-text leading-tight mb-1">
          {label}
        </h2>
        <p className="text-sm text-bubble-muted leading-snug">{description}</p>
      </div>
    </button>
  )
}
